import React from 'react';
import image from '../../../assets/ImagesSuggestions/img-equipment-and-material.jpg';

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

const  MaterialAndEquipmentSuggestions = () => {

    return (<div className='row '>
        <div className='col-12 d-flex justify-content-center align-items-center text-center'>
            <img className='h-270px w-400px' src={image} alt='add' />
        </div>
    </div>)

}

export  default MaterialAndEquipmentSuggestions;
